export default __webpack_public_path__ + "src/images/system_preface/4-dd94ec.png";